module.exports = __webpack_public_path__ + "media/images/jlp-features-sitter-applies-5fb0e8fcfb53029d578ac739efe321b8.svg";